import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {AssigneeSelectorMenuState} from '../state';
import Select2 from 'shared/components/Select2';
import ObjectSelect2 from 'shared/components/ObjectSelect2';
import _ from 'lodash';
import {useEffect, useRef, useState} from 'react';

const AssigneeSelectorMenu = observer(({uiState, isOpen}) => {
  const {assignee, position, isSpecificEmployee, employees, selectorLabel} = uiState;

  const closeTimeoutRef = useRef(null);
  const [showMenu, setShowMenu] = useState(isOpen);
  const [dropdownAnimationStatus, setDropdownAnimationStatus] = useState(isOpen ? 'is-open' : 'is-closed');

  useEffect(() => {
    if (isOpen) {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }
      setShowMenu(true);
      setDropdownAnimationStatus('is-open');
    } else {
      if (closeTimeoutRef.current) return;
      setDropdownAnimationStatus('is-closed');

      closeTimeoutRef.current = setTimeout(() => {
        setShowMenu(false);
      }, 400);
    }
  }, [isOpen]);

  if (!showMenu) return null;

  return(
    <div
      className={`assignee-selector-menu absolute z-index-1 p2 border bg-white rounded box-shadow-2 ${dropdownAnimationStatus}`}
      style={{...position, minWidth: 280}}
    >
        <Select2
          label={selectorLabel}
          value={assignee.assigneeType}
          onChange={(e) => uiState.updateAssignee({assigneeType: e.target.value, employee: null})}
        >
          <option value='employee'>{t('company_settings.documents.Employee')}</option>
          <option value='manager'>{t('company_settings.documents.Employee\'s Manager')}</option>
          <option value='specific_employee'>{t('company_settings.documents.Specific Employee')}</option>
        </Select2>
        {isSpecificEmployee &&
          <div className='mt2'>
            <ObjectSelect2
              searchable
              label='company_settings.documents.Employee'
              value={_.find(employees, {id: assignee.employee?.id})}
              onChange={(employee) => uiState.updateAssignee({employee})}
              items={employees}
            />
          </div>
        }
    </div>
  );
});

export default withState(AssigneeSelectorMenu, AssigneeSelectorMenuState);
